export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5677.5288c619.jpg";